<template>
  <div style="height: 100%">
    <img class="attendance-bg" src="../assets/images/bg.jpg" alt="" />
    <div class="attendance">
      <!--头部-->
      <div class="attendance-title">
        <span class="date-item">
          <el-date-picker class="date-text test-item" v-model="timeOb" clear-icon="el-icon-date" type="date"
            placeholder="选择日期" @change="changeDateGo">
          </el-date-picker>
          <i class="el-icon-caret-bottom el_icon_down"></i>
        </span>
        <span class="class-select">
          <el-select @change="changeTodayClass" v-model="valueClass" placeholder="请选择">
            <el-option v-for="item in todayClassList" :key="item.gradeId" :label="item.gradeName" :value="item.gradeId">
            </el-option>
          </el-select>
          <i class="el-icon-caret-bottom el_icon_down el_icon_sele_down"></i>
        </span>
        <span class="class-select">
          <el-select v-model="valueTime" placeholder="请选择" @change="changeTimeSchedule">
            <el-option v-for="(item, index) in optionsTime" :key="item.dailyScheduleId" :label="item.openTime" :value="item.dailyScheduleId">
            </el-option>
          </el-select>

          <i class="el-icon-caret-bottom el_icon_down el_icon_sele_down"></i>
        </span>
        上课出勤雷达统计
      </div>
      <!--左侧统计表-->
      <div class="left-statis">
        <div class="table-up">
          <p class="table-tt">上课班级出勤排名</p>
          <div class="table-box">
            <div class="table-thead">
              <dl>
                <dt>排名</dt>
                <dt>班级名称</dt>
                <dt>出勤率</dt>
              </dl>
            </div>
            <div class="table-tbody tgRoll">
              <div>
                <dl v-for="(item, index) in attendanceRanking" :key="item.index">
                  <dd>
                    <!-- <i v-if="index == 0" class="ranking-one"></i>
                      <i v-else-if="index == 1" class="ranking-two"></i> -->
                    <span>{{ index + 1 }}</span>
                  </dd>
                  <dd>{{ item.gradeName }}</dd>
                  <dd>{{ item.ranking }}%</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="divide3 table-down">
          <p class="table-tt">班级早到榜前10名</p>
          <div class="table-box">
            <div class="table-thead">
              <dl>
                <dt>姓名</dt>
                <dt>班级排名</dt>
                <dt>全校排名</dt>
              </dl>
            </div>
            <div class="table-tbody tgRoll">
              <div>
                <dl v-for="item in earlyArrival" :key="item.index">
                  <dd>{{ item.studentName }}</dd>
                  <dd>{{ item.classOrder }}</dd>
                  <dd>{{ item.schoolOrder }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--雷达统计-->
      <div class="echart-box">
        <!--雷达图-->
        <div class="echart-inner student-zoom">
          <img src="../assets/images/echart_bg.png" class="echart-inner-bg" />
          <!--中间倒计时-->
          <span class="center-dot">
            <span v-if="indexShow === 0" class="countdown">
              <img src="../assets/images/ellipsis.gif" class="ingGif" /><br />
              签到中<br />
              <b class="countdown-time">{{ clockTime }}</b>
            </span>
            <span v-else-if="indexShow === 1" class="default-text">未开始</span>
            <span v-else-if="indexShow === 2" class="default-text">上课中</span>
            <span v-else-if="indexShow === 3" class="default-text">已下课</span>
          </span>
          <span v-if="studentList.length > 0">
            <span v-for="item in studentList" :key="item.index" class="student-item"><img :src="item.studentLog" /><b>{{
              item.studentName || "未填写"
            }}</b></span>
          </span>
        </div>
        <!--今日寄语-->
        <div class="attendance-ritbot" v-if="siginSo">
          <span class="word-tt">今日寄语：</span>
          <div class="word-list" id="tgCars">
            <ul ref="box">
              <li>{{ siginSo }}</li>
            </ul>
          </div>
        </div>
        <!--签到人数统计：动态变动-->
        <div class="people-signin">
          <ul>
            <li>
              <i class="dot-white"></i>应到：<span>{{ studentCount }}人</span>
            </li>
            <li>
              <i class="dot-green"></i>实到：<span class="font-green">{{ studentSign }}人</span>
            </li>
          </ul>
        </div>
        <!-- 出勤位置展示 -->
        <p class="pos-hint">出勤位置展示：根据出勤时间由内到外进行展示。</p>
      </div>
      <!--右侧统计表-->
      <div class="right-statis">
        <div class="table-up" style="height: 35%" v-if="gradeGroupIntegralDtos && gradeGroupIntegralDtos.integrals &&
          gradeGroupIntegralDtos.integrals.length > 0
          ">
          <p class="table-tt">
            {{ gradeGroupIntegralDtos.gradeTitle }}金币排行榜
          </p>
          <div class="table-box integralGroup-table-box">
            <div class="table-thead">
              <dl>
                <dt>组名</dt>
                <dt>总金币</dt>
                <dt>组长</dt>
                <dt>排名</dt>
              </dl>
            </div>
            <div class="table-tbody tgRoll">
              <div>
                <dl v-for="item in gradeGroupIntegralDtos.integrals" :key="item.index">
                  <dd>{{ item.integralTeamName }}</dd>
                  <dd>{{ item.totalScore }}枚</dd>
                  <dd>{{ item.groupLeader || "未设置" }}</dd>
                  <dd>
                    <i v-if="item.order === 1" class="ranking-one"></i>
                    <i v-else-if="item.order === 2" class="ranking-two"></i>
                    <i v-else>{{ item.order || "暂无排名" }}</i>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="table-down" style="height: 60%">
          <p class="table-tt">【个人】学习积分（金币）排行榜</p>
          <div class="table-box integralGroup-table-box">
            <div class="table-thead">
              <dl>
                <dt>姓名</dt>
                <dt>所在小组</dt>
                <dt>总金币</dt>
                <dt>排名</dt>
              </dl>
            </div>
            <div class="table-tbody tgRoll" v-if="gradeIntegraMemberDataDtos && gradeIntegraMemberDataDtos.integralMembers">
              <div>
                <dl v-for="item in gradeIntegraMemberDataDtos.integralMembers" :key="item.index">
                  <dd :class="item.studentName && item.studentName.length > 0
                      ? ''
                      : 'gray'
                    ">
                    {{ item.studentName || "未填写" }}
                  </dd>
                  <dd>{{ item.integralTeamName }}</dd>
                  <dd>{{ item.totalScore }}枚</dd>
                  <dd>
                    <i v-if="item.order === 1" class="ranking-one"></i>
                    <i v-else-if="item.order === 2" class="ranking-two"></i>
                    <i v-else :class="item.order === 0 ? 'gray' : ''">{{
                      item.order || "暂无排名"
                    }}</i>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// jQuery
import $ from "jquery";
import { ClassAttendanceRadarChart, DailySchedulelist } from "network/radar";
import { GetStudentListByIds } from "network/students";
import { timeFormatNew } from "common/utils";
export default {
  name: "RadarClassAttendance",
  data() {
    return {
      timeOb: new Date(),
      gradeId: "",
      valueClass: "所属班级",
      valueTime: "课时时段",
      optionsTime: [],
      todayClassList: [],
      attendanceRanking: [], //上课班级出勤排名
      earlyArrival: [], //班级早到榜前10名
      gradeGroupIntegralDtos: { integrals: [] }, // 班级
      gradeIntegraMemberDataDtos: [], //个人
      studentSignInRecordList: [], //学生签到
      studentId: [], //该班级所有学生ID
      studentList: [],
      startTime: "", //当前课时的开始时间
      finishTime: "", //当前结束的开始时间
      siginSo: "", //寄语
      studentSign: "", //实到人数
      studentCount: "", //应到人数
      areaBgW: "",
      areaBgH: "",
      flagIndex: null, //0未开始，1签到中，2上课中，3已下课
      indexShow: null,
      timer: null,
      clockTime: null, //签到倒计时
      currentScheduleId: null, //当前选中的课时ID
    };
  },
  computed: {},
  watch: {},
  created() {
    let that = this;
    // 排行榜滚动
    var time = setInterval(function () {
      that.Scroll();
    }, 5000);
  },
  destroyed() {
    clearInterval(this.countDown);
  },
  mounted() {
    // 格式化三个接口的执行顺序
    this.getSelect1();

    window.onload = function () { };
  },
  destroyed() { },
  activated() { },
  methods: {
    // 执行顺序1
    async getSelect1() {
      let _this = this;
      let timeGet = timeFormatNew(this.timeOb, "yyyy-MM-dd");
      if (this.$route.query.dt) {
        this.timeOb = this.$route.query.dt;
        // 获取今天开课班级
        await this.getDailySchedulelist(this.$route.query.dt);
      } else {
        await this.getDailySchedulelist(timeGet);
      }
      this.timeDiffTime = setInterval(function () {
        _this.clockCountdown();
      }, 1000);
      this.getSelect2();
      this.$nextTick(() => {
        this.lunbo();
      });
    },
    // 执行顺序2
    async getSelect2() {
      await this.getClassAttendanceRadarChart();
      this.getSelect3();
    },
    // 执行顺序3
    async getSelect3() {
      await this.getStudeyDeisl();
      this.$nextTick(() => {
        this.init();
      });
    },
    //   选择时间
    changeDateGo(time) {
      this.timeOb = timeFormatNew(time, "yyyy-MM-dd");
      window.location.href = "/#/RadarClassAttendance?dt=" + this.timeOb;
      clearInterval(this.timer);
      // 格式化时间
      this.optionsTime = [];
      this.studentId = [];
      // 重新渲染，接口重连
      this.getSelect1();
    },
    // 选择班级
    changeTodayClass(val) {
      let _this = this;
      this.optionsTime = [];
      //   根据班级联动时间
      _this.todayClassList.map((org) => {
        if (org.gradeId === val) {
          // 处理多个课时的情况
          if (org.dailyScheduleChildStatisticDtos && org.dailyScheduleChildStatisticDtos.length > 0) {
            // 将多个课时添加到选项中
            this.optionsTime = org.dailyScheduleChildStatisticDtos.map(schedule => ({
              dailyScheduleId: schedule.dailyScheduleId,
              openTime: schedule.openTime,
              todayMessage: schedule.todayMessage,
              startTime: schedule.startTime,
              finishTime: schedule.finishTime
            }));
            // 默认选择第一个课时
            this.valueTime = this.optionsTime[0].dailyScheduleId;
            this.siginSo = this.optionsTime[0].todayMessage;
            this.startTime = this.optionsTime[0].startTime;
            this.finishTime = this.optionsTime[0].finishTime;
            this.currentScheduleId = this.optionsTime[0].dailyScheduleId;
          } else {
            // 兼容单个课时的情况
            this.valueTime = org.dailyScheduleId || org.gradeId;
            this.siginSo = org.todayMessage;
            this.startTime = org.startTime;
            this.finishTime = org.finishTime;
            this.currentScheduleId = org.dailyScheduleId || org.gradeId;
            this.optionsTime.push({ 
              dailyScheduleId: org.dailyScheduleId || org.gradeId,
              openTime: org.openTime,
              todayMessage: org.todayMessage,
              startTime: org.startTime,
              finishTime: org.finishTime
            });
          }
        }
      });
      this.valueClass = val;
      // 切换班级和学生接口
      this.getSelect2();
    },
    // 选择课时
    changeTimeSchedule(scheduleId) {
      // 根据选中的课时ID更新相关信息
      const selectedSchedule = this.optionsTime.find(item => item.dailyScheduleId === scheduleId);
      if (selectedSchedule) {
        this.siginSo = selectedSchedule.todayMessage;
        this.startTime = selectedSchedule.startTime;
        this.finishTime = selectedSchedule.finishTime;
        this.currentScheduleId = scheduleId;
        // 重新获取该课时的出勤数据
        this.getSelect2();
      }
    },
    // 剩余时间格式化
    countdown(times) {
      if (times > 0) {
        let hours = this.addZero(Math.floor((times / 1000 / 60 / 60) % 24));
        let minutes = this.addZero(Math.floor((times / 1000 / 60) % 60));
        let seconds = this.addZero(Math.floor((times / 1000) % 60)); //秒
        this.clockTime = `${hours}:${minutes}:${seconds}`;
      } else {
        // return "加载中";
      }
    },
    // 个位补零
    addZero(d) {
      return parseInt(d) < 10 ? "0" + d : d;
    },
    // 获取指定时间的今日开课班级列表
    async getDailySchedulelist(timeGet) {
      const { data: result } = await DailySchedulelist(timeGet);
      if (result.code === 1) {
        if (result.result && result.result.length > 0) {
          this.todayClassList = result.result;
          
          // 处理第一个班级的课时信息
          const firstClass = this.todayClassList[0];
          if (firstClass.dailyScheduleChildStatisticDtos && firstClass.dailyScheduleChildStatisticDtos.length > 0) {
            // 多个课时的情况
            this.optionsTime = firstClass.dailyScheduleChildStatisticDtos.map(schedule => ({
              dailyScheduleId: schedule.dailyScheduleId,
              openTime: schedule.openTime,
              todayMessage: schedule.todayMessage,
              startTime: schedule.startTime,
              finishTime: schedule.finishTime
            }));
            // 默认选择第一个课时
            this.valueTime = this.optionsTime[0].dailyScheduleId;
            this.siginSo = this.optionsTime[0].todayMessage;
            this.startTime = this.optionsTime[0].startTime;
            this.finishTime = this.optionsTime[0].finishTime;
            this.currentScheduleId = this.optionsTime[0].dailyScheduleId;
          } else {
            // 兼容单个课时的情况
            this.valueTime = firstClass.dailyScheduleId || firstClass.gradeId;
            this.siginSo = firstClass.todayMessage;
            this.startTime = firstClass.startTime;
            this.finishTime = firstClass.finishTime;
            this.currentScheduleId = firstClass.dailyScheduleId || firstClass.gradeId;
            this.optionsTime.push({ 
              dailyScheduleId: firstClass.dailyScheduleId || firstClass.gradeId,
              openTime: firstClass.openTime,
              todayMessage: firstClass.todayMessage,
              startTime: firstClass.startTime,
              finishTime: firstClass.finishTime
            });
          }
          
          this.valueClass = firstClass.gradeId;
        } else {
          this.todayClassList = [];
          this.valueClass = "所属班级";
          this.valueTime = "课时时段";
          this.siginSo = "";
          this.optionsTime = [];
          this.currentScheduleId = null;
          this.$alert("没有上课班级请选择其他上课时间的班级", '提示');
        }
      } else {
        this.$alert(result.message);
      }
    },
    // 获取数据
    async getClassAttendanceRadarChart() {
      // 当上一个接口返回数据未空时，中断进度
      if (this.todayClassList.length == 0) return false;
      let timeObj = timeFormatNew(this.timeOb, "yyyy-MM-dd");
      const { data: result } = await ClassAttendanceRadarChart({
        dt: this.startTime,
        gradeId: this.valueClass,
        dailyScheduleId: this.currentScheduleId, // 添加课时ID参数
      },true);
      if (result.code === 1) {
        if (result.result) {
          this.studentCount = result.result.studentCount;
          this.studentSign = result.result.studentSign;
          this.attendanceRanking = result.result.attendanceRanking;
          this.earlyArrival = result.result.earlyArrival;
          this.gradeGroupIntegralDtos = result.result.gradeGroupIntegralDtos;
          this.gradeIntegraMemberDataDtos =
            result.result.gradeIntegraMemberDataDtos;
          this.studentSignInRecordList = result.result.studentSignInRecordList;
          if (this.studentSignInRecordList) {
            this.studentId = this.studentSignInRecordList.map((org) => {
              return org.studentId;
            });
          }
        } else {
          this.$alert("该班级没有上课的课时，请选择其他班级");
        }
      } else {
        this.$alert(result.message);
      }
    },
    // 获取学生公共集合
    async getStudeyDeisl() {
      // 当上一个接口返回数据未空时，中断进度
      if (this.studentId.length > 0) {
        let studentSignIn = [];
        studentSignIn = this.studentSignInRecordList.map((org) => {
          return org;
        });
        const result = await GetStudentListByIds(this.studentId);
        if (result.data.code === 1) {
          this.studentList = result.data.result;
          studentSignIn.map((org) => {
            result.data.result.map((o) => {
              if (org.studentId === o.id) {
                org.studentLog = o.avatars;
              }
            });
          });
          this.studentList = studentSignIn;
        }
      } else {
        this.studentList = [];
      }
    },
    // 排行榜滚动
    Scroll() {
      $(".tgRoll").each(function () {
        var area = $(this);
        //单行高度
        var he = area.find("dl").height();
        //单次滚动行数
        // var lines = parseInt(area.height()/he);
        var lines = 4;
        if (area.height() >= area.find("dl").length * he) {
          return;
        } else {
          area.find("div").animate(
            {
              marginTop: "-" + he * lines,
            },
            200,
            function () {
              for (let i = 1; i <= lines; i++) {
                area.find("dl:first").appendTo(area.find("div"));
              }
              area.find("div").css({
                marginTop: 0,
              });
            }
          );
        }
      });
    },
    // 寄语轮播
    lunbo() {
      if (this.siginSo) {
        // this.$refs.box.style.left = "20px";
        let box = this.$refs.box;
        let boxWidth = box.offsetWidth;
        var left = null;
        this.timer = setInterval(function () {
          left -= 3;
          if (left < -boxWidth / 2) {
            left = 200;
          }
          box.style.left = left + "px";
        }, 50);
      } else {
        // clearInterval(timer)
      }
    },
    // 计算打卡倒计时
    clockCountdown() {
      var date = new Date();
      var now = date.getTime();
      //   //     //设置截止时间
      var str = new Date(this.startTime).getTime();
      var end = new Date(this.finishTime).getTime();
      //   课时开始前十分钟
      var tenTime = 10 * 60 * 1000;
      //   //      //时间差
      let diffTime = str - now;
      if (now < str) {
        if (diffTime < tenTime && diffTime > 0) {
          this.indexShow = 0;
          this.countdown(diffTime);
        } else {
          this.indexShow = 1;
        }
      } else if (now > str && now < end) {
        this.indexShow = 2;
      } else if (now > end) {
        this.indexShow = 3;
      }
    },
    loadUser: function (left, bottom) {
      (this.areaBgW = $(".echart-inner-bg").width()), //获取头像分布区域背景图片宽度
        (this.areaBgH = $(".echart-inner-bg").height()); //获取头像分布区域背景图片高度
      let _this = this;
      //用户总数
      var userCount = this.studentList.length;
      if (userCount == 0) return false;
      var minCount = 0; //用户循环初始化索引
      let circles = [
        {
          RadiusX: 0.16 * this.areaBgW,
          RadiusY: 0.16 * this.areaBgH,
          Count: 11,
        }, //第一圈距离中心点的半径为120 第一圈显示用户数 10个
        {
          RadiusX: 0.26 * this.areaBgW,
          RadiusY: 0.26 * this.areaBgH,
          Count: 17,
        }, //第二圈
        {
          RadiusX: 0.36 * this.areaBgW,
          RadiusY: 0.36 * this.areaBgH,
          Count: 24,
        },
        {
          RadiusX: 0.46 * this.areaBgW,
          RadiusY: 0.45 * this.areaBgH,
          Count: 31,
        },
      ];
      $(circles).each((v, j) => {
        //每一个用户对应的角度;
        var avd = 360 / j.Count;
        //每一个用户对应的弧度;
        var ahd = (avd * Math.PI) / 180;
        var maxCount = minCount + j.Count;
        if (minCount > userCount) return false;
        for (var i = minCount; i < maxCount; i++) {
          if (i > userCount) return false;
          var index = i - minCount;
          $(".student-item")
            .eq(i)
            .css({
              left: Math.sin(ahd * index) * j.RadiusX + left + 75,
              bottom: Math.cos(ahd * index) * j.RadiusY + bottom + 20,
            });
        }
        minCount += j.Count;
      });
    },
    init: function () {
      //   //中心点横坐标
      var dotLeft = ($(".echart-inner").width() - $(".center-dot").width()) / 2;
      //   //中心点纵坐标
      var dotBottom =
        ($(".echart-inner").height() - $(".center-dot").height()) / 2;
      if (this.studentId) {
        this.loadUser(dotLeft, dotBottom);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timeDiffTime);
  },
};
</script>
 
<style scoped src="../assets/css/radar.css"></style>
<style scoped>
.table-thead dl dt,
.table-tbody dl dd {
  float: left;
  font-size: 14px;
  padding: 6px;
  line-height: 24px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.left-table,
.center-table {
  margin-right: 2%;
}

.left-statis,
.right-statis {
  position: absolute;
  top: 70px;
  right: auto;
  bottom: 15px;
}

.left-statis {
  left: 30px;
}

.right-statis {
  right: 30px;
}

.table-up {
  height: 44%;
}

.table-down {
  height: 50%;
  margin-top: 6%;
  max-height: 480px;
}

.table-up,
.table-down {
  width: 280px;
  text-align: center;
}

.left-statis .table-tt,
.right-statis .table-tt {
  font-size: 14px;
}

.table-up .table-tt {
  height: 12%;
}

.table-up .table-box {
  height: 86%;
}

.table-down .table-tt {
  height: 8%;
}

.table-down .table-box {
  height: 90%;
}

.table-up .table-tbody {
  height: 89%;
}

.table-down .table-tbody {
  height: 93%;
}

.left-statis .table-thead dl dt,
.left-statis .table-tbody dl dd,
.right-statis .table-thead dl dt,
.right-statis .table-tbody dl dd {
  font-size: 12px;
  line-height: 18px;
  padding: 4px;
}

.table-up .table-thead dl dt,
.table-up .table-tbody dl dd,
.right-table .table-thead dl dt,
.right-table .table-tbody dl dd {
  width: 24%;
}

.table-up .table-thead dl dt:nth-child(2),
.table-up .table-tbody dl dd:nth-child(2),
.right-table .table-thead dl dt:nth-child(2),
.right-table .table-tbody dl dd:nth-child(2) {
  width: 49%;
}

.table-up .table-thead dl dt:first-child+dt,
.table-up .table-tbody dl dd:first-child+dd,
.right-table .table-thead dl dt:first-child+dt,
.right-table .table-tbody dl dd:first-child+dd {
  width: 49%;
}

/*IE兼容写法*/

.echart-box {
  width: 100%;
  height: 100%;
  padding-left: 330px;
  padding-top: 50px;
  padding-right: 330px;
  box-sizing: border-box;
}

.echart-inner {
  width: 100%;
  height: 100%;
  /*min-width:694px;min-height: 740px;background: url(../image/echart_bg.png) no-repeat center center;background-size:100% auto;*/
  position: relative;
  margin: auto;
}

.echart-inner-bg {
  width: auto;
  height: 100%;
  /*min-width:694px;*/
  position: absolute;
  transform: translate(-50%, -50%);
  /* transform: translateX(-50%); */
  top: 50%;
  left: 50%;
  /*margin-left:-347px;margin-top:-333px;*/
  z-index: 1;
}

.center-dot {
  width: 200px;
  line-height: 32px;
  height: 120px;
  display: inline-block;
  position: absolute;
  /*top:50%;left:50%;margin-top:-64px;margin-left:-100px ;*/
  color: #fdf405;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  padding-top: 6px;
  box-sizing: border-box;
  z-index: 111;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}

.ingGif {
  width: 30%;
  height: auto;
  margin-top: -15px;
  margin-bottom: 15px;
}

.countdown-time {
  font-size: 18px;
}

.countdown-time em {
  font-style: normal;
}

:deep(.default-text) {
  width: 200px;
  height: 48px;
  line-height: 48px;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -24px;
  margin-left: -100px;
  color: #fdf405;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
}

/* .student-zoom{width: 100%;height: 100%;position: relative;} */

.student-zoom :deep(.student-item) {
  display: inline-block;
  width: 48px;
  height: 62px;
  text-align: center;
  position: absolute;
  z-index: 111;
  border-radius: 10px;
}

.student-zoom :deep(.student-item img) {
  width: 38px;
  height: 38px;
  border-radius: 10px;
}

.student-zoom :deep(.student-item b) {
  display: block;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  margin-top: 4px;
}

.attendance-ritbot {
  width: 300px;
  position: fixed;
  top: 62px;
  left: 330px;
  text-align: left;
  line-height: 36px;
  z-index: 999;
}

.attendance-ritbot .word-list {
  width: 220px;
}

.people-signin {
  position: absolute;
  top: 110px;
  left: 330px;
}

.people-signin ul li {
  font-size: 16px;
  color: #fff;
  line-height: 28px;
}

.people-signin ul li span {
  font-size: 20px;
  font-weight: bold;
}

.dot-white,
.dot-green {
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}

.dot-white {
  background-color: #fff;
}

.dot-green {
  background-color: #1bef6b;
}

.integralGroup-table-box .table-thead dl dt,
.integralGroup-table-box .table-tbody dl dd,
.integral-box .table-thead dl dt,
.integral-box .table-tbody dl dd {
  width: 25% !important;
}

.pos-hint {
  font-size: 12px;
  color: #54ecff;
  position: absolute;
  left: 330px;
  bottom: 10px;
}

.divide3 .table-thead dl dt,
.divide3 .table-tbody dl dd {
  width: 33.33%;
}

.el_icon_sele_down {
  right: 8px;
}

.attendance-footer {
  width: 1440px;
  position: absolute;
  bottom: 15px;
  left: 50%;
  margin-left: -720px;
  text-align: left;
  padding: 0 30px;
  line-height: 36px;
}

.word-tt {
  color: #54ecff;
}

.word-list {
  font-size: 0;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 1300px;
  height: 36px;
  overflow: hidden;
}

.word-list ul {
  position: absolute;
  left: 0;
  top: 0;
}

.word-list ul li {
  float: left;
  color: #fff;
  font-size: 14px;
  margin-right: 15px;
}

.class-select :deep(.el-input__inner) {
  border: none;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: transparent;
  padding-left: 6px;
  padding-right: 6px;
  max-width: 132px;
  overflow: hidden;
  margin-right: 4px;
  background: transparent;
  color: #54ecff;
  padding-left: 10px;
  padding-right: 20px;
  height: 26px;
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
}

.class-select :deep(.el-input__suffix) {
  display: none;
}

.font-green {
  color: #1bef6b;
}
</style>